<div fxLayout="column" fxLayoutAlign="space-between stretch">
  <app-field-label-required-actions
    [control]="control"
    [indexControl]="indexControl"
    [dialogComponent]="dialogComponent"
    (updateField)="onUpdatedControl($event)"
    (deleteField)="onDeletedControl($event)"></app-field-label-required-actions>
  <div>
    <mat-divider></mat-divider>
    <mat-label class="mat-h5">Choix définis : </mat-label>
    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
      <mat-select #input="ngModel" [(ngModel)]="control.options.value"
                  [placeholder]="placeholder"
                  [matTooltip]="control.options.tooltip"
                  [required]="control.options.isRequired"
                  [attr.data-cy]="'select-input-'+placeholder"
      >
        <mat-option *ngFor="let option of control.options.options" [value]="option.key" [attr.data-cy]="'option-select-input-'+option.id">
          {{ option.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
